import { ChangeDetectorRef, Component, Input, OnInit, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonEnum } from 'src/app/core/enums/common';
import { HttpMethod } from 'src/app/core/enums/http-handlers';
import { KSURLS, URLS, UserProfileURL } from 'src/app/core/enums/urls';
import { AppService } from 'src/app/core/services/app.service';
import { SessionService } from 'src/app/core/services/session.service';

@Component({
  standalone: false,
  selector: 'app-user-institute-profile',
  templateUrl: './user-institute-profile.component.html',
  styleUrls: ['./user-institute-profile.component.scss']
})
export class UserInstituteProfileComponent implements OnInit {
  @Input() profileUrl: any;
  url: any;
  profileData: any;
  companiesListData: any = [];
  orgId: any;
  orgUserType: any;
  getProfileByUserData: any;
  RatingForm: FormGroup = new FormGroup({});
  myRating: any = 0;
  buttonName: any = CommonEnum.UPDATE;
  getUserSkillsGoalsData: any;
  isLoading: boolean = true;
  hasError: boolean = false;

  constructor(
    private sessionService: SessionService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    public appService: AppService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
  ) { }

  ngOnInit(): void {
    this.GetprofileByUrl();
  }

  GetprofileByUrl() {
    // Guard: Check if profileUrl is valid
    if (!this.profileUrl || this.profileUrl.trim() === '') {
      this.hasError = true;
      this.isLoading = false;
      return;
    }
    
    this.isLoading = true;
    this.hasError = false;
    this.ratingFormMethod();
    const url = UserProfileURL.profileByUrl;
    this.sessionService.commonApiCall(
      url + '/' + this.profileUrl,
      HttpMethod.GET,
      null, (res: any, statusFlag: boolean) => {
        this.ngZone.run(() => {
          if (statusFlag && res) {
            this.profileData = res;
            if (this.profileData) {
              this.getUserSkillsGoals();
              if (!this.profileData?.isLocked) {
                this.getProfileByUser();
              }
            }
          } else {
            this.hasError = true;
          }
          this.isLoading = false;
          this.sessionService.hide();
        });
      }
    );
  }

  getUserSkillsGoals() {
    this.sessionService.commonApiCall(
      KSURLS.getUserSkillsGoalsByUser + "/" + this.profileData?.user_Id,
      HttpMethod.GET,
      null,
      (res: any, statusFlag: boolean) => {
        this.ngZone.run(() => {
          if (statusFlag) {
            this.getUserSkillsGoalsData = res;
          }
          this.sessionService.hide();
        });
      }
    );
  }

  getProfileByUser() {
    this.sessionService.commonApiCall(
      UserProfileURL.accOrgProfileByUser + "/" + this.profileData?.user_Id,
      HttpMethod.GET,
      null,
      (res: any, statusFlag: boolean) => {
        this.ngZone.run(() => {
          if (statusFlag) {
            this.getProfileByUserData = res;
          }
          this.sessionService.hide();
        });
      }
    );
  }

  ratingFormMethod() {
    this.RatingForm = this.fb.group({
      mentorUserId: [this.profileData?.user_Id],
      rating: [this.myRating],
      reviewText: ['', Validators.maxLength(200)],
    });
    this.buttonName = 'save';
  }


}
